import React, { useEffect, useState } from 'react'
import './SalesDepartment.css'
import { Button, Calendar, Col, Dropdown, Menu, Radio, Row } from 'antd'
import images1 from '../../assets/images1.jfif'
import Day from './Day';
import SalesTimeSheet from './SalesTimeSheet';
import SalesCalender from './SalesCalender';
import SalesShift from './SalesShift';
import { useNavigate } from "react-router-dom";
import NewSideBar from '../NewSideBar/NewSideBar';
import { useParams } from 'react-router-dom';
import { BASE_URL, FetchAttendanceDay } from '../../utils/constant';
import AddStaff from '../AddStaff/AddStaff';
import EmpTeamAdmin from '../EmpTeamAdmin/EmpTeamAdmin';
import AllCurrentStaff from '../AllCurrentStaff/AllCurrentStaff';
import EditStaffInfo from '../EditStaffInfo/EditStaffInfo';
import DeactivatedStaff from '../AllCurrentStaff/DeactivatedStaff';
import { useSelector } from 'react-redux';
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleLeft } from "react-icons/fa6";
function SalesDepartment({salesDepartmentId, onBack}) {
    console.log('salesDepartmentId',salesDepartmentId)
    const userInfo = useSelector((state) => state.signUp.signUpDetails);

    const [attendance, setAttendance] = useState("atten");
    const [sales, setSales] = useState();
    const [empClick, setEmpClick] = useState('empteamadmin')
    const currentYear = new Date().getFullYear();
  const currentDate = new Date();

  const currentMonth = currentDate.getMonth() + 1; 
  const currentYearSelected = currentDate.getFullYear();

  const [selectedMonthNumber, setSelectedMonthNumber] = useState(currentMonth);
  const [selectedYearNumber, setSelectedYearNumber] = useState(currentYearSelected);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  // let dynamicDate;
  const BoCreatedAt = userInfo?.userRole == "businessOwner" ? userInfo?.createdAt : userInfo?.boOwner?.createdAt;

  const dynamicDate = new Date(BoCreatedAt);
  console.log('dynamicDate',dynamicDate)
  useEffect(() => {
    console.log('userInfouserInfo',userInfo)
  }, [userInfo]);
  let endYear;
    
    if (currentMonth < 4) {
        endYear = currentYear -1;
    } else {
        endYear = currentYear;
    }
    
    const startYear = dynamicDate?.getMonth() < 3 ? dynamicDate?.getFullYear() - 1 : dynamicDate?.getFullYear();
    const numberOfYears = endYear - startYear + 1;
    
    const fiscalYear = Array.from({ length: numberOfYears }, (_, index) => {
        const year = startYear + index;
        return `${year}-${year + 1}`;
    });
    
    console.log(fiscalYear);
    const defaultSelectedMonth = `${currentMonth < 10 ? '' : ''}${currentMonth}-${currentYear}`;

    const [selectedMonth, setSelectedMonth] = useState(defaultSelectedMonth);

    const currentFiscalYear = `${currentYear}-${currentYear + 1}`;
    const defaultSelectedFiscalYear = fiscalYear.includes(currentFiscalYear) ? currentFiscalYear : fiscalYear[0];
    const [selectedFiscalYea, setSelectedFiscalYea] = useState(defaultSelectedFiscalYear);
    useEffect(() => {
      // console.log('s')
      setSelectedFiscalYea(defaultSelectedFiscalYear)
      // getStaffDayList();
    }, [defaultSelectedFiscalYear]);
console.log('selectedFiscalYea',defaultSelectedFiscalYear)
  const updateMonths = (selectedYear) => {
    console.log('yearSeleced',selectedYear)
    const startYear = parseInt(selectedYear?.split('-')[0]);
    const endYear = parseInt(selectedYear?.split('-')[1]);
  
    const currentDate = new Date();
    const currentMonth = currentDate?.getMonth() + 1; // Adding 1 to convert from 0-indexed to 1-indexed
    const dynamicMonth = dynamicDate?.getMonth() + 1; 
  console.log('dynamicMonth',dynamicMonth)
    const months = [];
    if(startYear == dynamicDate?.getFullYear()){
      for (let month = dynamicMonth; month <= 12; month++) {
        if (startYear < currentYear || (startYear === currentYear && month <= currentMonth)) {
          months.push(`${month < 10 ? '' : ''}${month}-${startYear}`);
        }
      }
    
      for (let month = 1; month <= 3; month++) {
        if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
          months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
        }
      }
    }else if(endYear == dynamicDate?.getFullYear()){
      for (let month = dynamicMonth; month <= 3; month++) {
        if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
          months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
        }
      }
    }else{

      for (let month = 4; month <= 12; month++) {
        if (startYear < currentYear || (startYear === currentYear && month <= currentMonth)) {
          months.push(`${month < 10 ? '' : ''}${month}-${startYear}`);
        }
      }
      
      for (let month = 1; month <= 3; month++) {
        if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
          months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
        }
      }
    }
  
    return months;
  };
 
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const getMonthName = (monthNumber) => {
    

    if (monthNumber >= 1 && monthNumber <= 12) {
      return monthNames[monthNumber - 1];
    } else {
      return 'Invalid Month';
    }
  };
  const handleFiscalYearChang = (event) => {
    const newFiscalYear = event.target.value;
    console.log('newFiscalYear',newFiscalYear)
    setSelectedFiscalYea(newFiscalYear);
    setSelectedMonth(null);
  };

  const handleMonthChange = (event) => {
    const selectedMonthValu = event.target.value;
    console.log(event.target.value)
    setSelectedMonth(selectedMonthValu);
    // You can log the selected month and year to the console here
    const [selectedMonthNumberEvent, selectedYearNumberEvent] = selectedMonthValu.split('-');
    console.log(`Selected Month: ${selectedMonthNumberEvent}, Selected Year: ${selectedYearNumberEvent}`);
    setSelectedMonthNumber(selectedMonthNumberEvent)
    setSelectedYearNumber(selectedYearNumberEvent)
  };
  const handleFiscalYearChan = (year) => {
    setSelectedFiscalYea(year);
    setSelectedMonth(null);
  };
  const fiscalYearMenu = (
    <Menu onClick={(e) => handleFiscalYearChan(e.key)}>
      {fiscalYear.map((year) => (
        <Menu.Item key={year}>
          {year}
        </Menu.Item>
      ))}
    </Menu>
  );

    // const currentYear = new Date().getFullYear();
    
//     const currentDate = new Date();

//     const currentMonth = currentDate.getMonth() + 1; 
// const currentYearSelected = currentDate.getFullYear();

// const [selectedMonthNumber, setSelectedMonthNumber] = useState(currentMonth);
// const [selectedYearNumber, setSelectedYearNumber] = useState(currentYearSelected);
//     const fiscalYear = [];
    
//     for (let i = 1; i <= 10; i++) {
//         const previousYear = currentYear - i;
//         const startYear = previousYear;
//         const endYear = startYear + 1;
//         fiscalYear.push(`${startYear}-${endYear}`);
//     }
//     const defaultSelectedMonth = `${currentMonth < 10 ? '' : ''}${currentMonth}-${currentYear}`;

// const [selectedMonth, setSelectedMonth] = useState(defaultSelectedMonth);

//     const currentFiscalYear = `${currentYear}-${currentYear + 1}`;
//     const defaultSelectedFiscalYear = fiscalYear.includes(currentFiscalYear) ? currentFiscalYear : fiscalYear[0];
//     const [selectedFiscalYea, setSelectedFiscalYea] = useState(defaultSelectedFiscalYear);

//   const updateMonths = (selectedYear) => {
//     const startYear = parseInt(selectedYear.split('-')[0]);
//     const endYear = parseInt(selectedYear.split('-')[1]);
  
//     const currentDate = new Date();
//     const currentMonth = currentDate.getMonth() + 1; // Adding 1 to convert from 0-indexed to 1-indexed
  
//     const months = [];
//     for (let month = 4; month <= 12; month++) {
//       if (startYear < currentYear || (startYear === currentYear && month <= currentMonth)) {
//         months.push(`${month < 10 ? '' : ''}${month}-${startYear}`);
//       }
//     }
  
//     for (let month = 1; month <= 3; month++) {
//       if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
//         months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
//       }
//     }
  
//     return months;
//   };
//   const monthNames = [
//     'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
//   ];
//   const handleFiscalYearChang = (event) => {
//     const newFiscalYear = event.target.value;
//     console.log('newFiscalYear',newFiscalYear)
//     setSelectedFiscalYea(newFiscalYear);
//     setSelectedMonth(null);
//   };

//   const handleMonthChange = (event) => {
//     const selectedMonthValu = event.target.value;
//     console.log(event.target.value)
//     setSelectedMonth(selectedMonthValu);
//     // You can log the selected month and year to the console here
//     const [selectedMonthNumberEvent, selectedYearNumberEvent] = selectedMonthValu.split('-');
//     console.log(`Selected Month: ${selectedMonthNumberEvent}, Selected Year: ${selectedYearNumberEvent}`);
//     setSelectedMonthNumber(selectedMonthNumberEvent)
//     setSelectedYearNumber(selectedYearNumberEvent)
//   };
//   const handleFiscalYearChan = (year) => {
//     setSelectedFiscalYea(year);
//     setSelectedMonth(null);
//   };
//   const fiscalYearMenu = (
//     <Menu onClick={(e) => handleFiscalYearChan(e.key)}>
//       {fiscalYear.map((year) => (
//         <Menu.Item key={year}>
//           {year}
//         </Menu.Item>
//       ))}
//     </Menu>
//   );

//   const fiscalYearMenu = (
//     <Menu onClick={(e) => handleFiscalYearChange(e)}>
//       {fiscalYear.map((year) => (
//         <Menu.Item key={year} value={year}>
//           {year}
//         </Menu.Item>
//       ))}
//     </Menu>
//   );
    const { id } = useParams();
    // const [size, setSize] = useState('large');
    const [size, setSize] = useState("july");
const [selectedFiscalYear, setSelectedFiscalYear] = useState('FY 2020-2021');
    const [staffData, setStaffData] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);
    useEffect(() => {
        console.log('s')
        getStaffDayList();
      }, [selectedMonthNumber]);

      const getStaffDayList = async () =>{
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchAttendanceDay}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
                "staffId" : salesDepartmentId,
     "month" : parseInt(selectedMonthNumber),
     "year" : parseInt(selectedYearNumber)
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            setStaffData(data?.data)
            console.log('StaffToday',data)
            
      
          
          } else {
            const data = await response.json();
            console.log('stafTodayerr',data)
            // toast.error(data.errorMessage, {
            //   position: toast.POSITION.TOP_RIGHT,
            // });
            
          }
        };
       
        await fetchData();
       
      }
  
    const handleFiscalYearChange = (year) => {
      setSelectedFiscalYear(year);
    };
  
    const handleHistory = () => {
      window.history.back();
    };
  
    const fiscalYears = ['FY 2020-21', 'FY 2021-22', 'FY 2022-23', 'FY 2023-24']; // Add more years as needed
  
    // const items = fiscalYears.map((year) => ({
    //   key: year,
    //   label: <span onClick={() => handleFiscalYearChange(year)}>{year}</span>,
    // }));
    const handleSizeChange = (e) => {
        setSize(e.target.value);
    };
    const [salescomponent, setSalescomponents] = useState('day')
    const handleSalesChange = (data) => {
        console.log('e', data)
        setSalescomponents(data);
       
    };
    const navigate = useNavigate();
    const handlehistory = () => {
        // navigate("/history");
        onBack();
        const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};

        const stateToSave = {
          attendance:savedState.attendance,
          salesDepartmentId:savedState.salesDepartmentId,
          currentStaffId:savedState.currentStaffId,
          click : savedState.click,
          empClick:savedState.empClick,
          sales:'',
          currentStaff:savedState.currentStaff ,
          active:savedState.active ,
        };
        sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
        // window.history.back()
    };
    const generateCalendarYears = (startYear, endYear) => {
        const years = [];
        for (let year = startYear; year <= endYear; year++) {
          years.push(`FY ${year - 1}-${year.toString()}`);
        }
        return years;
      };
      const generateMonthsForFiscalYear = () => {
        const fiscalStartMonth = selectedFiscalYear.includes('20') ? 'june' : 'july';
        const fiscalEndMonth = selectedFiscalYear.includes('20') ? 'may' : 'april';
        const months = [];
        let currentMonth = fiscalStartMonth;
    
        while (currentMonth !== fiscalEndMonth) {
          months.push(currentMonth);
          currentMonth = getNextMonth(currentMonth);
        }
    
        months.push(fiscalEndMonth);
        return months;
      };
      
      const getNextMonth = (currentMonth) => {
        const monthsOrder = [
          'january',
          'february',
          'march',
          'april',
          'may',
          'june',
          'july',
          'august',
          'september',
          'october',
          'november',
          'december',
        ];
        const currentMonthIndex = monthsOrder.indexOf(currentMonth);
        return monthsOrder[(currentMonthIndex + 1) % monthsOrder.length];
      };
      const calendarYears = generateCalendarYears(2010, 2023); // Change the range as needed
      useEffect(() => {
        const months = generateMonthsForFiscalYear();
        setSelectedMonths(months);
      }, [selectedFiscalYear]);
      
      const items = calendarYears.map((year) => ({
        key: year,
        label: <span onClick={() => handleFiscalYearChange(year)}>{year}</span>,
      }));

      function formatTime(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const minutes = Math.round((milliseconds % 3600000) / 60000);
      
        if (hours > 0) {
          return `${hours}:${minutes < 10 ? '0' : ''}${minutes} hr`;
        } else {
          return `${minutes} min`;
        }
      }
    // const items = [
    //     {
    //         key: '1',
    //         label: (
    //             <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
    //                 1st menu item
    //             </a>
    //         ),
    //     },
    //     {
    //         key: '2',
    //         label: (
    //             <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com">
    //                 2nd menu item
    //             </a>
    //         ),
    //     },
    //     {
    //         key: '3',
    //         label: (
    //             <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com">
    //                 3rd menu item
    //             </a>
    //         ),
    //     },
    // ];
    return (
        <div>
            <Row lg={30} className='items-start'>
            {/* <Col lg={4}>
          <NewSideBar setAttendance={setAttendance} setSales={setSales}/>
        </Col>
         */}
              <Col lg={3}>
                    <Button className='text-[15px] bg-[#DBE8FB] border-[#DBE8FB] h-14 rounded-xl w-full flex items-center justify-center' size={size} onClick={handlehistory}>
                      <FaAngleLeft className='!mr-[5px] text-[16px]' />  Back
                    </Button>
                    <div className='rounded-2xl bg-[#EDF3FD] !p-3 !mt-3'>
                        <div className='w-16 h-16 rounded-full overflow-hidden mx-auto'>
                            <img src={staffData?.staffDetail?.faceRegisterUrl || staffData?.staffDetail?.logo} className='w-full h-full object-cover' />
                        </div>
                        <div className='text-[15px] text-center font-sbold !mt-[4px]'>{capitalizeFirstLetter(staffData?.staffDetail?.firstName)} {capitalizeFirstLetter(staffData?.staffDetail?.lastName)}</div>
                        <div className='bg-[#D5E4FA] rounded-[10px] !px-4 !py-2 !mt-3'>
                            {/* <div>
                                <p className='sale-base'>Base Site</p>
                                <p className='sale-name'>Keshar Towers</p>
                            </div> */}
                            <div className='mt-2 !mb-3'>
                                <p className='text-xs text-[#4B8AEB]'>Mobile No</p>
                                <p className='text-sm font-sbold'>{staffData?.staffDetail?.phoneNumber}</p>
                            </div>
                            <div className='!mb-3'>
                                <p className='text-xs text-[#4B8AEB]'>Designation</p>
                                <p className='text-sm font-sbold'>{capitalizeFirstLetter(staffData?.staffDetail?.designationName)}</p>
                            </div>
                            <div className='!mb-3'>
                                <p className='text-xs text-[#4B8AEB]'>Department</p>
                                <p className='text-sm font-sbold'>{capitalizeFirstLetter(staffData?.staffDetail?.departmentName)}</p>
                            </div>
                            <div className='!mb-3'>
                                <p className='text-xs text-[#4B8AEB]'>Main Location</p>
                                <p className='text-sm'>
                                  {staffData?.staffDetail?.mainSite?.map((data,index) => { return (
                                  <span key={index} className='font-sbold'>
                                    {index > 0 && " "} {capitalizeFirstLetter(data?.locationName2)}
                                  </span>
                                  )})}
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
              <Col lg={21}>
                <div className='ml-3 '>
                  <div className='bg-[#E4EEFC] rounded-3xl gap-2 inline-flex items-center !px-4 h-14' >
                    <span className='text-[#0F94AF] text-[15px] font-sbold !mr-3'>Attendance</span>
                    <Button className={`border-0 rounded-3xl min-w-[105px] !text-sm !outline-none ${salescomponent === 'day' ? 'bg-[#5E96ED] text-white' : 'bg-[#B6D0F7] text-black'}`} onClick={() => handleSalesChange('day')} value="day">Day</Button>
                    <Button className={`border-0 rounded-3xl min-w-[105px] !text-sm !outline-none ${salescomponent === 'timesheet' ? 'bg-[#5E96ED] text-white' : 'bg-[#B6D0F7] text-black'}`} onClick={() => handleSalesChange('timesheet')} value="timesheet">Timesheet</Button>
                    <Button  className={`border-0 rounded-3xl min-w-[105px] !text-sm !outline-none ${salescomponent === 'calender' ? 'bg-[#5E96ED] text-white' : 'bg-[#B6D0F7] text-black'}`} onClick={() => handleSalesChange('calender')} value="calender">Calender</Button>
                    <Button  className={`border-0 rounded-3xl min-w-[105px] !text-sm !outline-none ${salescomponent === 'shift' ? 'bg-[#5E96ED] text-white' : 'bg-[#B6D0F7] text-black'}`} onClick={() => handleSalesChange('shift')} value="shift">Shift Plan</Button>
                  </div>

                        {salescomponent === 'shift' ? '' :
                            <>
                                <div className='flex defaulTabs gap-3 mt-3'>

                                    {/* <Radio.Group value={size} onChange={handleSizeChange} className='flex ml-2 '>
                                        <Radio.Button value="july" style={{ backgroundColor: `${size === 'july' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'july' ? 'white' : 'black'}`, borderColor: `${size === 'july' ? '#363743' : '#EBEBEC'}` }}>July <br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="june" style={{ backgroundColor: `${size === 'june' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'june' ? 'white' : 'black'}`, borderColor: `${size === 'june' ? '#363743' : '#EBEBEC'}` }}><p>Jun <br /> <span className='fort-year'>2023</span></p></Radio.Button>
                                        <Radio.Button value="may" style={{ backgroundColor: `${size === 'may' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'may' ? 'white' : 'black'}`, borderColor: `${size === 'may' ? '#363743' : '#EBEBEC'}` }}>May<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="apr" style={{ backgroundColor: `${size === 'apr' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'apr' ? 'white' : 'black'}`, borderColor: `${size === 'apr' ? '#363743' : '#EBEBEC'}` }}>Apr<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="mar" style={{ backgroundColor: `${size === 'mar' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'mar' ? 'white' : 'black'}`, borderColor: `${size === 'mar' ? '#363743' : '#EBEBEC'}` }}>Mar<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="feb" style={{ backgroundColor: `${size === 'feb' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'feb' ? 'white' : 'black'}`, borderColor: `${size === 'feb' ? '#363743' : '#EBEBEC'}` }}>Feb<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="jan" style={{ backgroundColor: `${size === 'jan' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'jan' ? 'white' : 'black'}`, borderColor: `${size === 'jan' ? '#363743' : '#EBEBEC'}` }}>Jan<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="dec" style={{ backgroundColor: `${size === 'dec' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'dec' ? 'white' : 'black'}`, borderColor: `${size === 'dec' ? '#363743' : '#EBEBEC'}` }} >Dec<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="nov" style={{ backgroundColor: `${size === 'nov' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'nov' ? 'white' : 'black'}`, borderColor: `${size === 'nov' ? '#363743' : '#EBEBEC'}` }}>Nov<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="oct" style={{ backgroundColor: `${size === 'oct' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'oct' ? 'white' : 'black'}`, borderColor: `${size === 'oct' ? '#363743' : '#EBEBEC'}` }} >Oct<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="sep" style={{ backgroundColor: `${size === 'sep' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'sep' ? 'white' : 'black'}`, borderColor: `${size === 'sep' ? '#363743' : '#EBEBEC'}` }} >Sep<br /> <span className='fort-year'>2023</span></Radio.Button>
                                        <Radio.Button value="aug" style={{ backgroundColor: `${size === 'aug' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'aug' ? 'white' : 'black'}`, borderColor: `${size === 'aug' ? '#363743' : '#EBEBEC'}` }}>Aug<br /> <span className='fort-year'>2023</span></Radio.Button>

                                    </Radio.Group> */}
{/* <Radio.Group value={size} onChange={(e) => setSize(e.target.value)} className="flex ml-2 ">
  {selectedMonths.map((month, index) => {
    const fiscalYear = selectedFiscalYear.split(' ')[1].split('-')[0];
    const nextFiscalYear = selectedFiscalYear.split(' ')[1].split('-')[1];
    const displayFiscalYear = month === 'January' ? nextFiscalYear : (index > 6 ? nextFiscalYear : fiscalYear);

    return (
      <Radio.Button
        key={month}
        value={month}
        style={{
          backgroundColor: `${size === month ? '#00305F' : '#F1F6FD'}`,
          color: `${size === month ? 'white' : 'black'}`,
          borderColor: `${size === month ? '#363743' : '#EBEBEC'}`,
        }}
      >
        {`${month.charAt(0).toUpperCase() + month.slice(1)} FY ${displayFiscalYear}`}
      </Radio.Button>
    );
  })}
</Radio.Group> */}
 <Radio.Group className='radioBtnMonths !bg-[#F1F6FD]' value={selectedMonth} onChange={(e) => handleMonthChange(e)}>
        {updateMonths(selectedFiscalYea).slice() // Create a copy of the array
    .reverse().map((month) => (
          <Radio.Button
            key={month}
            value={month}
            className='text-center !px-4 !py-[5px] !rounded-[11px]'
            style={{
              backgroundColor: `${selectedMonth === month ? '#00305F' : 'transparent'}`,
              color: `${selectedMonth === month ? 'white' : 'black'}`,
              borderColor: `${selectedMonth === month ? '#363743' : 'transparent'}`,
            }}
          >
            <div className='text-[17px] font-sbold'>{monthNames[parseInt(month.split('-')[0]) - 1]}</div>
            <div className='text-[11px] font-normal leading-none'>{month.split('-')[1]}</div>
          </Radio.Button>
        ))}
      </Radio.Group>

      {/* <Dropdown menu={{ items }} placement='bottom'>
        <Button className='simple-btn1'>{selectedFiscalYear}</Button>
      </Dropdown> */}
      <Dropdown overlay={fiscalYearMenu} placement="bottom">
        <Button className="bg-[#F1F6FD] border-[#F1F6FD] font-semibold h-[38px] flex items-center !pr-3 !outline-none">{selectedFiscalYea} <FaAngleDown className='ml-2 text-xs text-[#4B8AEB]' /></Button>
      </Dropdown>
                                </div>
                                <div className='!mt-3'>
                                    <p className='text-[#0F94AF] text-[15px] font-sbold'>Summary</p>
                                </div>
                   
                                <div className='inline-flex mt-2 bg-[#F1F6FD] rounded-2xl !p-3 gap-2'>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-bold'>{staffData?.totalDaysInMonth}</p>
                                        <p className='text-[15px] text-[#818A97]'>Total day</p>
                                    </div>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-sbold'>{staffData?.totalWorkingDays}</p>
                                        <p className='text-[15px] text-[#818A97]'>TWD</p>
                                    </div>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-sbold'>{staffData?.totalPresentDay}</p>
                                        <p className='text-[15px] text-[#818A97]'>Present</p>
                                    </div>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-sbold'>{staffData?.remainingDays}</p>
                                        <p className='text-[15px] text-[#818A97]'>Remaining</p>
                                    </div>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-sbold'>{staffData?.totalAbset}</p>
                                        <p className='text-[15px] text-[#818A97]'>Absent</p>
                                    </div>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-sbold'>{formatTime(staffData?.totalOTHr)}</p>
                                        <p className='text-[15px] text-[#818A97]'>OT Hours</p>
                                    </div>
                                    <div className='bg-[#D0E1F9] rounded-[10px] min-w-[67px] h-16 inline-flex items-center justify-center flex-col !px-2'>
                                        <p className='text-[22px] font-sbold'>{formatTime(staffData?.totalLTHr)}</p>
                                        <p className='text-[15px] text-[#818A97]'>LT Hours</p>
                                    </div>
                                    {/* <div style={{ display: "flex", backgroundColor: "#D0E1F9", marginRight: "7px", padding: "3px", borderBottomLeftRadius: "7px", borderTopLeftRadius: "7px", borderTopRightRadius: "7px", borderBottomRightRadius: "7px" }}>
                                        <Row>
                                            <div sm={12} className='mr-1 line'>
                                                <p style={{ textAlign: "center", fontWeight: "bold" }}>1</p>
                                                <p style={{ fontSize: "9px", fontWeight: "bold", color: "#959595" }}>Paid Leave</p>
                                            </div>
                                            <div sm={12} className='ml-1'>
                                                <p style={{ textAlign: "center", fontWeight: "bold" }}>1</p>
                                                <p style={{ fontSize: "9px", fontWeight: "bold", color: "#959595" }}>Unpaid Leave</p>
                                            </div>
                                        </Row>

                                    </div> */}
                                    {/* <div style={{ width: "20%", backgroundColor: "#E0EBFB", marginRight: "7px", padding: "0px", borderBottomLeftRadius: "7px", borderTopLeftRadius: "7px", borderTopRightRadius: "7px", borderBottomRightRadius: "7px" }}>
                                        <div className=' sale-bf '>
                                            <Row>
                                                <Col sm={12}>
                                                    <p className='sale-bo'>Bonus</p>
                                                </Col>
                                                <Col sm={12}>
                                                    <p className='sale-bo'>Fine</p>
                                                </Col>
                                            </Row>

                                        </div>
                                        <div>
                                            <Row>
                                                <Col sm={12}>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <p className='sale-day1 ml-2'>Days</p>
                                                            <p className='sale-four ml-2'>4</p>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <p className='sale-day1'>Amount</p>
                                                            <p className='sale-500'>500</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={12}>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <p className='sale-day1'>Days</p>
                                                            <p className='sale-four'>4</p>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <p className='sale-day1'>Amount</p>
                                                            <p className='sale-5001'>500</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div> */}
                                    {/* <div className='sale-lastsecond mr-2'>
                                        <div className='flex justify-between'>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>OT</p>
                                            <p style={{ fontWeight: "bold", fontSize: "10px" }}>4</p>
                                        </div>
                                        <div className='flex justify-between sale-botom'>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>OT Hours</p>
                                            <p style={{ fontWeight: "bold", fontSize: "10px" }}>{formatTime(staffData?.totalOTHr)}</p>
                                        </div>
                                        <div className='flex justify-between'>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>2 Settled</p>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>2 Pending</p>
                                        </div>
                                    </div> */}
                                    {/* <div className='sale-lastsecond'>
                                        <div className='flex justify-between'>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>OT</p>
                                            <p style={{ fontWeight: "bold", fontSize: "10px" }}>4</p>
                                        </div>
                                        <div className='flex justify-between sale-botom'>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>LT Hours</p>
                                            <p style={{ fontWeight: "bold", fontSize: "10px" }}>{formatTime(staffData?.totalLTHr)}</p>
                                        </div>
                                        <div className='flex justify-between'>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>2 Settled</p>
                                            <p style={{ fontSize: "10px", fontSize: "9px", fontWeight: "bold", color: "#959595" }}>2 Pending</p>
                                        </div>
                                    </div> */}

                                </div>
                            </>
                        }
                       
                        {salescomponent === 'day' ? <Day staffData={staffData}  selectedYearNumber={selectedYearNumber} selectedMonthNumber={selectedMonthNumber}
                        /> : 
                        
                        salescomponent === 'timesheet' ? <SalesTimeSheet staffData={staffData} selectedFiscalYea={selectedFiscalYea} selectedYearNumber={selectedYearNumber} selectedMonthNumber={selectedMonthNumber} /> : salescomponent === 'calender' ? <SalesCalender salesDepartmentId={salesDepartmentId} selectedYearNumber={selectedYearNumber} selectedMonthNumber={selectedMonthNumber}/> : salescomponent === 'shift' ? <SalesShift fiscalYear={fiscalYear}  fiscalYearMenu={fiscalYearMenu} defaultSelectedFiscalYear={defaultSelectedFiscalYear} salesDepartmentId={salesDepartmentId} selectedYearNumber={selectedYearNumber} currentYearSelected={currentYearSelected} selectedMonthNumber={selectedMonthNumber}/> : ''}
                    </div>

                </Col>
               
            </Row>
        </div>
    )
}

export default SalesDepartment